import {SOPutWork} from '../../core/work/so-put-work';
import {WorkCore} from './work.core';
import {SOGetWork} from '../../core/work/so-get-work';
import {FormField, SelectionOption} from 'lionheartland';
import {putWorkFormFieldOptions} from './put-work-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {DeficiencyCore} from '../deficiency/deficiency.core';
import {SOGetDeficiency} from '../../core/deficiency/so-get-deficiency';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutWork extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putWorkFormFieldOptions);

  RequestClass = SOPutWork

  constructor(
    public entityCore: WorkCore
  ) {
    super();
    if (putWorkFormFieldOptions.deficiency) {
      putWorkFormFieldOptions.deficiency.makeCore = true;
    }
    if (putWorkFormFieldOptions.project) {
      putWorkFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('active'),
      this.getFormValueFromIdentifier(
        'deficiency',
        SOGetDeficiency,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}